import React, { useState } from 'react';
import ParticleBackground from './ParticleBackground';
import VideoBackground from './VideoBackground';

export type BackgroundType = 'particles' | 'video' | 'both' | 'none';

interface BackgroundManagerProps {
  backgroundType?: BackgroundType;
  onBackgroundChange?: (type: BackgroundType) => void;
  showControls?: boolean;
}

const BackgroundManager: React.FC<BackgroundManagerProps> = ({
  backgroundType = 'both',
  onBackgroundChange,
  showControls = false
}) => {
  const [currentBackground, setCurrentBackground] = useState<BackgroundType>(backgroundType);

  const handleBackgroundChange = (type: BackgroundType) => {
    setCurrentBackground(type);
    onBackgroundChange?.(type);
  };

  return (
    <>
      {/* Background Components */}
      {currentBackground === 'particles' && <ParticleBackground />}
      {currentBackground === 'video' && <VideoBackground />}
      {currentBackground === 'both' && (
        <>
          <VideoBackground overlayOpacity={0.8} />
          <ParticleBackground />
        </>
      )}

      {/* Background Controls */}
      {showControls && (
        <div className="fixed top-4 right-4 z-50 bg-black/50 backdrop-blur-sm rounded-lg p-3">
          <div className="text-white text-sm mb-2">Background:</div>
          <div className="flex gap-2">
            {(['particles', 'video', 'both', 'none'] as BackgroundType[]).map((type) => (
              <button
                key={type}
                onClick={() => handleBackgroundChange(type)}
                className={`px-3 py-1 text-xs rounded ${
                  currentBackground === type
                    ? 'bg-purple-600 text-white'
                    : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                }`}
              >
                {type.charAt(0).toUpperCase() + type.slice(1)}
              </button>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default BackgroundManager; 